import React, { useState, useEffect } from 'react';
import {
  collection,
  query,
  orderBy,
  addDoc,
  onSnapshot,
  getDocs // ✅ الحل هنا
} from 'firebase/firestore';

import { db } from '../../firebase';
import RestaurantSidebar from '../../components/RestaurantSidebar';
import ChatMessage from '../../components/ChatMessage';
import './RestaurantChat.css';

const RestaurantChat = () => {
  const restaurantId = localStorage.getItem('restaurantId');
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [chatTarget, setChatTarget] = useState('admin'); // 'admin' or 'driver'
  const [targetId, setTargetId] = useState('');
  const [drivers, setDrivers] = useState([]);

useEffect(() => {
  if (!restaurantId) return;
  const fetchDrivers = async () => {
    const snapshot = await getDocs(collection(db, 'drivers'));
    const list = snapshot.docs.map(doc => ({
      id: doc.id,
      name: doc.data().name || 'بدون اسم'
    }));
    setDrivers(list);
  };
  fetchDrivers();
}, [restaurantId]);


  useEffect(() => {
    if (!restaurantId) return;

    const chatId = chatTarget === 'admin'
    ? `admin_restaurant_${restaurantId}`
      : `restaurant_driver_${restaurantId}_${targetId}`;

    const q = query(collection(db, `chats/${chatId}/messages`), orderBy('timestamp', 'asc'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    return () => unsubscribe();
  }, [restaurantId, chatTarget, targetId]);

  const sendMessage = async () => {
    if (!newMessage.trim()) return;

     const chatId = chatTarget === 'admin'
     ? `admin_restaurant_${restaurantId}`
      : `restaurant_driver_${restaurantId}_${targetId}`;

       await addDoc(collection(db, `chats/${chatId}/messages`),
        {
      sender: 'restaurant',
      message: newMessage.trim(),
      timestamp: new Date(),
    });

    setNewMessage('');
  };

  return (
    <div className="restaurant-page">
      <RestaurantSidebar />
      <div className="chat-content">
        <h2>💬 التواصل مع {chatTarget === 'admin' ? 'الإدارة' : 'السائق'}</h2>

        <div className="chat-header">
          <label>اختر الجهة:</label>
          <select value={chatTarget} onChange={e => setChatTarget(e.target.value)}>
            <option value="admin">الإدارة</option>
            <option value="driver">سائق</option>
          </select>

          {chatTarget === 'driver' && (
            <select value={targetId} onChange={e => setTargetId(e.target.value)}>
              <option value="">-- اختر سائق --</option>
              {drivers.map(driver => (
                <option key={driver.id} value={driver.id}>{driver.name}</option>
              ))}
            </select>
          )}
        </div>

        <div className="chat-box">
          {messages.length === 0 ? (
            <div className="empty-chat"><p>لا توجد رسائل حالياً.</p></div>
          ) : (
            messages.map(msg => (
              <ChatMessage key={msg.id} message={msg} />
            ))
          )}
        </div>

        <div className="chat-input">
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="اكتب رسالتك هنا..."
            onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
          />
          <button onClick={sendMessage}>إرسال</button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantChat;
